/*eslint-disable */
// import gpath_configModel from '../../Model/gpath_config'
import request from '../../Utils/curl'
import Utility from "../../Utils/utility";

let GPathConfig = {
  /**
   * gpcList
   */
  async gpcList (context, whereFilter=null) {
    try{
      Utility.showLoader = true;
      Utility.loadingMsg = "Please wait....";

      let post_data = new FormData();  
      if (whereFilter) {
        post_data.append('filter', JSON.stringify(whereFilter))
      }

      return await request.curl(context, "gpath_config_list", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at gpcList() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  },

  /**
   * gpcView
   */
  async gpcView (context, gpcId, pdtId) {
    try {      
      let post_data = new FormData();
      if (gpcId) {
        post_data.append('gpc_id', gpcId);
      }
      else if (pdtId) {
        post_data.append('gpc_pdt_id', pdtId);
      }

      return await request.curl(context, "gpath_config_view", post_data)
      .then(async response => {
        return response;
      });
    } 
    catch (err) {
      console.error("Exception occurred at gpcView() and Exception:",err.message)
    }    
  },

  /**
   * gpcAdd
   */
  async gpcAdd (context, gpcObj) {
    try{
      let post_data = new FormData();
    
      for (let key in gpcObj) {
        post_data.append(key, gpcObj[key]);
      }

      return await request.curl(context, "gpath_config_add", post_data)
      .then(async response => {
          return response;
      });
    }
    catch(err){
      console.error('Exception occurred at gpcAdd() and Exception:',err.message)
    }
  },

  /**
   * gpcEdit
   */
  async gpcEdit (context, gpcObj) {
    try{
      let post_data = new FormData();
    
      for (let key in gpcObj) {
        post_data.append(key, gpcObj[key]);
      }

      return await request.curl(context, "gpath_config_edit", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at gpcEdit() and Exception:',err.message)
    }
  },

  /**
   * gpcDelete
   */
  async gpcDelete (context, gpcId) {
    try{
      let post_data = new FormData();
      
      post_data.append('gpc_id', gpcId);

      return await request.curl(context, "gpath_config_delete", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.log('Exception occurred at gpcDelete() and Exception:',err.message)
    }
  },

  /**
   * gpath Config Publish Unpublish
   */
  async gpathConfigPublishUnpublish (context, gpathsConfig) {
    try {
      let postData = new FormData()
      postData.append("gpc_pdt_id", gpathsConfig.gpc_pdt_id)
      postData.append("deleted", gpathsConfig.deleted)
      return await request.curl(context, "gpath_config_publish_unpublish", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at gpathConfigPublishUnpublish() and Exception:", err.message)
    }
  },
}

export {
  GPathConfig
}
